<template>
    <div class="main">
        <c-panel title="CONFIGURAÇÕES DE HORÁRIO" titleIcon="fas fa-clock">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="A configuração define a grade padrão de horários: dias, aulas, intervalos e horários. Turma sem configuração continua funcionando como hoje — segunda a sexta, sem hora definida."></el-alert>

            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="16">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar configuração..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/configuracao-horario/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVA CONFIGURAÇÃO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 70px;">cod</th>
                            <th>Nome</th>
                            <th class="hidden-mobile">Escopo</th>
                            <th class="hidden-mobile">Turno</th>
                            <th>Dias</th>
                            <th class="hidden-mobile u-text-center">Situação</th>
                            <th style="width: 130px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td class="hidden-mobile">{{ item.id }}</td>
                            <td>{{ item.nome }}</td>
                            <td class="hidden-mobile">{{ item.instituicao ? item.instituicao.nome : 'Rede' }}</td>
                            <td class="hidden-mobile">{{ rotuloTurno(item.turno) }}</td>
                            <td>{{ nomesDias(item.dias_semana) }}</td>
                            <td class="hidden-mobile u-text-center">{{ item.situacao ? 'Ativa' : 'Inativa' }}</td>
                            <td class="u-text-center acao">
                                <router-link v-if="podeEscrever" :to="'/admin/configuracao-horario/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0">
                            <td colspan="7" class="u-text-center">Nenhuma configuração cadastrada.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                @current-change="irParaPagina" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>
<script>
/**
 * BLOCO F — itens 11 e 105 do edital (Timbé do Sul/SC). Fase F10.
 *
 * Interface para `api/configuracao-horario`. Nenhuma regra é reimplementada aqui: a
 * resolução da grade efetiva, o cruzamento com os dias de funcionamento e a validação
 * dos horários são do backend.
 *
 * Esconder botão NÃO é segurança — o backend continua sendo a autoridade. `podeEscrever`
 * só evita oferecer ao usuário uma ação que a API vai recusar.
 */
export default {
    data: () => ({
        statusList: false,
        filtro: { nome: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: [],
        // Convenção canônica do backend: 0 = domingo … 6 = sábado. O usuário vê o nome.
        nomeDoDia: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
    }),
    computed: {
        podeEscrever () {
            return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo))
        }
    },
    mounted () { this.carregar() },
    methods: {
        carregar () {
            this.statusList = false
            this.items = []
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/configuracao-horario/getAllPaginate?page=${this.paginate.page}`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => {
                this.items = r.data.data || []
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        irParaPagina (p) { this.paginate.page = p; this.carregar() },
        nomesDias (dias) {
            if (!Array.isArray(dias) || !dias.length) return '—'
            return dias.map(d => this.nomeDoDia[parseInt(d)]).join(', ')
        },
        rotuloTurno (t) {
            if (t === null || t === undefined || t === '') return 'Todos'
            const r = { 0: 'Matutino', 1: 'Vespertino', 2: 'Noturno', 4: 'Integral' }
            return r[parseInt(t)] !== undefined ? r[parseInt(t)] : t
        },
        excluir (id) {
            this.$confirm('Excluir esta configuração de horários?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/configuracao-horario/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    // A mensagem do backend é preservada: ela explica o motivo real
                    // (por exemplo, configuração já usada por um quadro de horários).
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Configuração excluída.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (erro) { return typeof erro === 'string' ? erro : (erro.text || 'Não foi possível concluir.') }
    }
}
</script>
